import { MONTHS_OF_THE_YEAR } from "@costory/shared/const"
import dayjs from "@costory/shared/dayjs"

import { Th } from "@costory/front/pages/Budgets/components/Th"
import {
  bigBlackBorder,
  smallBlackBorder,
  mediumGrayBorder,
} from "@costory/front/pages/Budgets/consts"

interface BudgetTableHeadeProps {
  monthsOffset: number
}

export const BudgetTableHead = ({ monthsOffset }: BudgetTableHeadeProps) => {
  const offsetMonthsOfTheYear = MONTHS_OF_THE_YEAR.map(
    (month) => (month + monthsOffset) % MONTHS_OF_THE_YEAR.length,
  )
  return (
    <thead
      style={{
        position: "sticky",
        borderBottom: smallBlackBorder,
        zIndex: 1,
        top: 0,
      }}
    >
      <tr style={{ borderBottom: bigBlackBorder }}>
        <Th
          colSpan={3}
          style={{
            textAlign: "center",
            borderRight: mediumGrayBorder,
          }}
        >
          Virtual dimension value
        </Th>
        {offsetMonthsOfTheYear.map((month, index) => (
          <Th
            key={month}
            style={{
              textAlign: "center",
              ...(month === offsetMonthsOfTheYear.length - 1 && {
                borderRight: bigBlackBorder,
              }),
              ...(index === offsetMonthsOfTheYear.length - 1 && {
                borderRight: mediumGrayBorder,
              }),
            }}
          >
            {dayjs().month(month).format("MMM")}
          </Th>
        ))}
        <Th
          style={{
            textAlign: "center",
            borderRight: mediumGrayBorder,
          }}
        >
          YTD
        </Th>
        <Th
          style={{
            textAlign: "center",
            borderRight: "none",
          }}
        >
          Total
        </Th>
      </tr>
    </thead>
  )
}
